export const terminationTypes = [
    'at_own_request', 'by_mutual_agreement', 'after_the_agreed_deadline'
];
